import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { environment } from 'src/environments/environment';
import { RecoverPasswordRequest } from '../../requests/user/recover-password.request';
import { RecoverPasswordResponse } from '../../responses/user/recover-password.response';

@Injectable({
  providedIn: 'root'
})
export class RecoverPasswordService extends CommonService {

  constructor(private router: Router,
    private httpClient: HttpClient) {
    super();
  }

  public verifyToken(token: string): Observable<ReturnStruct> {

    return this.httpClient.get<ReturnStruct>(environment.urlApiUser + `RecoverPassword?token=${token}`)
      .pipe(
        catchError(this.handleError)
    )
  }

  public recoverPassword(body: RecoverPasswordRequest): Observable<ReturnStruct> {

    return this.httpClient.put<ReturnStruct>(environment.urlApiUser + "RecoverPassword", body)
      .pipe(
        catchError(this.handleError)
    )
  }

  public recoverPasswordToken(login: string, idHealthUnit): Observable<RecoverPasswordResponse> {

    let body  = {
      login: login,
      idHealthUnit: idHealthUnit
    };

    return this.httpClient.post<RecoverPasswordResponse>(environment.urlApiUser + "RecoverPassword", body)
      .pipe(
        catchError(this.handleError)
    )
  }
}
